import { createSelector } from 'reselect';
import { stringToArray } from 'utils';
import {
  BRANDS,
  SIZES,
  COLORS,
  PATTERNS,
  STYLES,
  CONTEXTS,
  AVAILABILITY,
  PRICE_TYPES,
  MIN_PRICE,
  MAX_PRICE,
  PRICE,
  IN_STORE,
} from 'constants/filters';
import { PROMO_DISCOUNT_TYPE } from 'constants';

const filtersSelector = (productFilters) => productFilters.filters;
const labelsSelector = (productFilters) => productFilters.filterLabels;

const promotionsSelector = (productDetails) => productDetails.data?.promotions || productDetails.promotions;

const filterKeys = [BRANDS, SIZES, COLORS, PATTERNS, PRICE_TYPES, STYLES, CONTEXTS, AVAILABILITY];

export const getChosenFilters = createSelector(
  filtersSelector,
  labelsSelector,
  (filters, labels = {}) => {
    let chosenFilters = [];
    Object.keys(filters).forEach((key) => {
      if (filterKeys.includes(key)) {
        const categoryFilters = stringToArray(filters[key]).map((value) => ({ key, value, label: labels[value] }));
        chosenFilters = [...chosenFilters, ...categoryFilters];
      }
    });

    if (filters[MIN_PRICE] || filters[MAX_PRICE]) {
      const min = filters[MIN_PRICE];
      const max = filters[MAX_PRICE];
      const minPrice = `${min && `${!max ? '> ' : ''}$${min}`}`;
      const maxPrice = `${max && `${!min ? '< ' : ''}$${max}`}`;
      const priceFilter = { key: PRICE, value: `${minPrice}${min && max && ' - '}${maxPrice}` };
      chosenFilters = [priceFilter, ...chosenFilters];
    }

    if (filters[IN_STORE]) {
      chosenFilters.push({
        key: IN_STORE,
        value: 'In My Store',
      });
    }

    return chosenFilters;
  },
);

export const getPercentOff = createSelector(
  promotionsSelector,
  (promotions) => {
    // 113 is the only type of promo to affect product price
    const discountEligiblePromotion = promotions?.find(({ type }) => String(type) === PROMO_DISCOUNT_TYPE);
    if (!discountEligiblePromotion) return null;
    return discountEligiblePromotion.percentOff;
  },
);

export default getChosenFilters;
